import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { styled } from "@mui/material";
const LoaderWrapper = styled("div")(() => {
    return {
        background: "rgba(0,0,0,0.5) !important",
        position: "absolute",
        width: "100%",
        height: "100%",
        zIndex: 99999,
        top: 0,
        span: {
            position: "fixed",
            top: "50%",
            left: "50%",
        },
    };
});
const useLoaderHandlers = () => {
    const [loader, setLoader] = useState(false);
    const [message, setMessage] = useState("");
    const setLoading = (config) => {
        console.log(":::setLoading Working:::");
        (config === null || config === void 0 ? void 0 : config.message) && setMessage(message);
        setLoader(true);
    };
    const unSetLoading = () => {
        console.log(":::unSetLoading Working:::");
        message && setMessage("");
        setLoader(false);
    };
    return {
        loader,
        message,
        setLoading,
        unSetLoading,
    };
};
let actions = {
    setLoading: (data) => {
        console.log("Oh! setLoading not works");
    },
    unSetLoading: () => {
        console.log("Oh! unSetLoading not works");
    },
};
export const useCommonLoader = () => actions;
export const Loader = () => {
    const { loader, message, setLoading, unSetLoading } = useLoaderHandlers();
    useEffect(() => {
        actions = {
            setLoading,
            unSetLoading,
        };
    });
    return React.createElement(LoaderUI, { loader: loader, message: message });
};
export const LoaderUI = ({ loader, message, }) => (React.createElement(LoaderWrapper, { style: { display: loader ? "block" : "none" }, className: "common_loader" },
    React.createElement(CircularProgress, { color: "primary" }),
    message ? React.createElement("p", null, message) : null));
